/**
 *  Service
 */

//jshint ignore:start
(function (itxApp) {

    'use strict';

    angular.module('itxApp.common')
        .service('ItxProductSwiperSvc', ItxProductSwiperSvc);

    ItxProductSwiperSvc.$inject = ['$rootScope', '$q', 'ItxConstants', 'ItxUtilsFct'];

    /**
     * ProductSwiper Service
     * @name ItxProductSwiperSvc
     * @type ItxProductSwiperSvc
     * @constructor
     */
    function ItxProductSwiperSvc($rootScope, $q, ItxConstants, ItxUtilsFct) {
    

        var _this = this;
        _this.$rootScope = $rootScope;
        _this.$q = $q;
        _this.ItxUtilsFct = ItxUtilsFct;

        _this.swiper = null;

        _this.visibleProduct = null;

        _this.renderedItems = [];
        _this.swiperEnabled = true;

        _this.relatedProducts = [];
        _this.latestProducts = [];
        _this.showRelatedSection = false;
        _this.index = 0;

        var categoryFilter = JSON.parse(sessionStorage.getItem(ItxConstants.DuttiCategoryFilterKey));
        if (categoryFilter &&
            categoryFilter.products &&
            categoryFilter.categoryId &&
            inditex.iCategoryId === categoryFilter.categoryId) {
            _this.catentries = categoryFilter.products;
        } else {
            _this.catentries = [];
        }

        _this.products = {};
        _this.currentIndex = null;
        _this.wideEyesEnabled = null;
        
        //_this.isCompatibleBrowser = this._isCompatibleBrowser();

        inditex.getXconfiguracionValue('WIDE_EYES_ENABLED', function (status, value) {
            if (value === '1') {
                _this.wideEyesEnabled = true;
            } else {
                _this.wideEyesEnabled = false;
            }
        });
    }

    ItxProductSwiperSvc.prototype.setCatentries = function(catentries) {
        var _this = this;
        _this.catentries = catentries;
        //_this.isCompatibleBrowser = _this._isCompatibleBrowser();
    };

    /** ESTO NO SE UTILIZA
     * Set current visible product in swiper 
     */
    // ItxProductSwiperSvc.prototype.setVisibleProduct = function (productId, colorId, catentries) {
    //     var _this = this;
    //     var index = -1;
    //     //check if current index has the same productId. If it does, then it is the correct one.
    //     var catentry = catentries[_this.index];
    //     if (catentry && parseInt(catentry.id) === parseInt(productId)) {
    //         index = _this.index;
    //     } else {
    //         index = _.findIndex(catentries, function (catentry) {
    //             return parseInt(catentry.id) === parseInt(productId) &&
    //                 parseInt(catentry.colorId) === parseInt(colorId);
    //         });
    //     }
        
    //     //if there is no product, search just for productId
    //     if (index === -1) {
    //         index = _.findIndex(catentries, function (catentry) {
    //             return parseInt(catentry.id) === parseInt(productId);
    //         });
    //     }

    //     if (index !== -1) {
    //         _this.visibleProduct = {
    //             productId: productId,
    //             colorId: colorId,
    //             name: catentries[index].name,
    //             type: catentries[index].type,
    //             parentId: catentries[index].parent
    //         };
    //         _this.index = index;
    //         _this.renderedItems = [];
    //         _this.renderedItems.push(index);

    //         if (index > 0) {
    //             _this.renderedItems.push(index - 1);
    //         }
    //         if (index < catentries.length - 1) {
    //             _this.renderedItems.push(index + 1);
    //         }

    //         _this.$rootScope.$broadcast('itx-photo-swiper-svc:visible-product', _this.visibleProduct);
    //         _this.ItxUtilsFct.publish('product-detail:product-changed', _this.visibleProduct);
    //     }
    // };

    ItxProductSwiperSvc.prototype.isRendered = function(productId, colorId) {
        var _this = this;
        if (!_this.isCompatibleBrowser() || !_this.catentries) {
            return true;
        }

        if (_this.catentries.length < 3) {
            return true;
        }
        var current = _this.catentries[_this.renderedItems[0]];
        var prev = _this.catentries[_this.renderedItems[1]];
        var next = _this.catentries[_this.renderedItems[2]];
        if (current && current.id == productId) {
            return true;
        } else if (prev && prev.id == productId) {
            return true;
        } else if (next && next.id == productId) {
            return true;
        }

        return false;

    };

    ItxProductSwiperSvc.prototype.changeColor = function(productId, oldColorId, newColorId) {
        var _this = this;
        if (!_this.visibleProduct || _this.visibleProduct.productId != productId) {
            return;
        }

        var catentry = _this.catentries[_this.index];
        if (catentry && catentry.colorId == oldColorId) {
            catentry.colorId = newColorId;
        }
    };

    /**
     * Set swiper inside this service
     */
    ItxProductSwiperSvc.prototype.setSwiper = function (swiper) {
        this.swiper = swiper;
    };

    /**
     * Slide to previous
     */
    ItxProductSwiperSvc.prototype.slidePrev = function () {
        this.swiper.slidePrev();
        this.index--;
    };

    /**
     * Slide to next
     */
    ItxProductSwiperSvc.prototype.slideNext = function () {
        this.swiper.slideNext(); 
        this.index++;
    };

    /*
     * Slide to next or previous, depending on the productId
     */
    ItxProductSwiperSvc.prototype.goToProduct = function(productId, colorId) {

        var _this = this;
        var key = productId + '-' + colorId;
        if (!_this.renderedItems || !_this.renderedItems.length) {
            return;
        }
        var prev = _this.catentries[_this.renderedItems[1]];
        var next = _this.catentries[_this.renderedItems[2]];
        if (prev && prev.id == productId && prev.colorId == colorId) {
            _this.slidePrev();
        } else if (next && next.id == productId && next.colorId == colorId) {
            _this.slideNext();
        }
    };

    /**
     * Check if browser is compatible with swiper
     */
    ItxProductSwiperSvc.prototype.isCompatibleBrowser = function () {
        return true;
        
        var ua = window.navigator.userAgent;
        //return false;
        var msie = ua.indexOf('MSIE '   );

        if (msie > 0) {
            // IE 10 or older
            return false;
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11
            return false;
        }

        //If not catentries then we don´t use swiper
        if (!this.catentries || (this.catentries && this.catentries.length === 0)) {
            return false;
        }

        return true;
    };

    /**
     * Function useful for reduce bindings in non active swiper slides
     */
    ItxProductSwiperSvc.prototype.isProductVisible = function (productId, colorId) {
        return true;

        if (!this.isCompatibleBrowser) {
            return true;
        }
        if (!this.visibleProduct) {
            return false;
        }
        if (parseInt(this.visibleProduct.productId) === productId && parseInt(this.visibleProduct.colorId) === colorId) {
            return true;
        } else {
            return false;
        }
    };



    /**
     * Show/Hide related section
     */
    ItxProductSwiperSvc.prototype.toggleShowRelatedSection = function (showRelatedSection) {
        var _this = this;

        if (_this.wideEyesEnabled) {
            _this.showRelatedSection = showRelatedSection;
        } else if (_this.relatedProducts.length > 0 || _this.latestProducts.length > 0) {
            _this.showRelatedSection = showRelatedSection;
        } else {
            _this.showRelatedSection = false;
        }
    };


})(window.itxApp);
